import React from 'react';

import { Button } from '@xingternal/button';
import { IconSorting, IconTick } from '@xingternal/icons';
import { usePopOver } from '@xingternal/pop-over';

import { useBreakpoints } from '@/hooks';

import { DEFAULT_SORT, SORT_OPTIONS } from '../../../../constants';
import { useSearchQuery } from '../../../../contexts';

import * as S from './sorting-button.styles';

type Props = {
  className?: string;
};

export const SortingButton: React.FC<Props> = ({ className }) => {
  const {
    queryParams: [{ sort }, setQueryParams],
  } = useSearchQuery();
  const { isMobile, isTablet } = useBreakpoints();
  const popOver = usePopOver();

  const onClickSortingButton = (): void => {
    popOver.togglePopOver();
  };

  const sorting = sort ?? DEFAULT_SORT;
  const sharedProps = {
    size: isTablet ? 'small' : 'medium',
    icon: IconSorting,
    onClick: onClickSortingButton,
    type: 'button',
    innerRef: popOver.triggerRef,
    className: className,
    children: SORT_OPTIONS[sorting],
  } as const;

  return (
    <>
      {isMobile ? <S.TextButton {...sharedProps} iconAfter /> : <Button variant="tertiary" {...sharedProps} />}
      <S.Menu
        onOutsideClick={popOver.handleHide}
        triggerRef={popOver.triggerRef}
        show={popOver.show}
        showCloseButton={false}
      >
        {Object.entries(SORT_OPTIONS).map(([option, text]) => (
          <S.SingleSelect
            key={option}
            onClick={(): void => {
              popOver.handleHide();
              setQueryParams({ sort: option });
            }}
            {...(sorting === option && { selected: true, icon: IconTick, iconAfter: true })}
          >
            {text}
          </S.SingleSelect>
        ))}
      </S.Menu>
    </>
  );
};
